<template>
  <div class="lr_titles">
    <div class="item_title">
      <span class="title-inner">{{ title }}</span>      
      <div class="brand-bottom" v-if="isShowBrandBottom">
        <div class="border-comm apply" @click="brandBottomSelect('apply')" :class="{'select-color' : btnType === 'apply'}"><span>申请</span></div>
        <div class="border-comm register" @click="brandBottomSelect('register')" :class="{'select-color' : btnType === 'register'}"><span>注册</span></div>
      </div>     
      <div class="range-span" v-if="isShowIcon">
        <div class="border-comm enprise" @click="selectType('1')" :class="{'select-color' : iconSelect === '1'}"><span>企业</span></div>
        <div class="border-comm colleage" @click="selectType('2')" :class="{'select-color' : iconSelect === '2'}"><span>高校</span></div>
        <div class="border-comm organ" @click="selectType('3')" :class="{'select-color' : iconSelect === '3'}"><span>机构</span></div>
      </div>
    </div>
    <div
      :class="title !== '' ? 'item_title_content' : 'item_title_content_def'"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconSelect: '1',
      btnType: 'apply'
    };
  },
  props: {
    title: {
      type: String,
      default: () => "",
    },
    isShowIcon: {
      type: Boolean,
      default: false
    },
    isShowBrandBottom: {
      type: Boolean,
      default: false
    }
  },
  created() {},

  mounted() {},
  methods: {
    selectType(type){
      this.iconSelect = type
      this.$emit('selectType',type)
    },
    brandBottomSelect(type){
      this.btnType = type
      this.$emit('brandBottomSelect',type)
    }
  },
};
</script>
<style lang='scss' scoped>
$item-title-height: 45px;
$item_title_content-height: calc(100% - 45px);

.lr_titles {
  box-sizing: border-box;
  .item_title {
    height: $item-title-height;
    line-height: $item-title-height;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
   // background: linear-gradient(to right, rgb(7,28,140), rgb(4,71,156) 40%, transparent);
    .title-inner {
      font-weight: 900;
      letter-spacing: 2px;
      background: linear-gradient(
        92deg,
        #0072ff 0%,
        #00eaff 48.8525390625%,
        #01aaff 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .item_title_content {
    height: $item_title_content-height;
   // background: linear-gradient(to right,rgb(5,13,63),rgb(3,22,74),transparent);
  }

  .item_title_content_def {
    width: 100%;
    height: 100%;
  }
  .range-span {
    display: flex;
    align-items: flex-end;
    > div {
      top: -12px;
      left: 6px;
      color: #0EF9FF;
      cursor: pointer;
    }
  }
  .select-color {
    color: #FDC29E !important;
  }

  .border-comm {
    background: rgba(1,2,40,0);
    border: 1px solid;
    border-image: linear-gradient(0deg, #FEC59E) 1 1;
    box-shadow: 0px 0px 9px 1px rgba(230,117,81,0.44);
    border-radius: 2px;
    margin-right: 10px;
    cursor: pointer;
    display: inline-block;
    position: relative;
    width: 37px;
    height: 19px;
    color: #0EF9FF;
    > span {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      top: -12px;
      left: 6px;
      position: absolute;
    }
  }
  .brand-bottom {
    display: flex;
    flex-direction: row;
    width: 110px;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>